import React from 'react';
import store from '../../../store/configuration';
import Tooltip from '../../common/Tooltip';
import Assets from '../../../Assets';

export default class UnitTypeCalculationPropertiesRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            editing: false,
            value: props.text
        }
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            value: props.text
        })
    }

    onButtonClick = e => {
        if (this.state.editing) {
            this.updateName();
            this.props.step.props.onFormModelChange()
        }

        this.setState({
            editing: !this.state.editing
        })
    }

    updateName = () => {
    }

    onInputChange = e => {
        this.setState({
            value: e.target.value
        })
    }

    render() {
        return (
            <tr>
                <td>
                    <div className="flex-center-v">
                        {this.props.warning ? (
                            <span>
                                <Tooltip icon={Assets.warning} style="warning" text={this.props.warning}/>
                            </span>
                        ) : ''}

                        <span>
                            {this.state.editing ? (
                                <input type="text" value={this.state.value} onChange={this.onInputChange}/>
                            ) : (
                                this.props.row.text || this.props.text
                            )}
                        </span>

                        {this.props.allowEdit ? (
                            <span className="configuration-property-edit-button" onClick={this.onButtonClick}>
                                {this.state.editing ? (
                                    <svg viewBox="0 0 612 612" width="12px" height="12px">
                                        <g>
                                            <polygon
                                                points="573.75,0 183.485,516.968 37.657,380.702 0,422.548 189.452,612 612,38.843"
                                                fill="#2b54b8"/>
                                        </g>
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 512 512" width="12px" height="12px">
                                        <g>
                                            <path
                                                d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981   c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611   C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069   L27.473,390.597L0.3,512.69z"
                                                fill="#2b54b8"/>
                                        </g>
                                    </svg>
                                )}
                            </span>
                        ) : ''}
                    </div>
                </td>

                {[this.props.row.temperature, this.props.row.pressure].map((x, idx) => (
                    <td key={idx}>
                        {x.visible ? (
                            <div className="flex-center-v">
                                <span>{this.props.step.renderFieldv2(x)}</span>
                                <span className="text-muted" style={{paddingLeft: 4}}>{x.unit}</span>
                            </div>
                        ) : <React.Fragment></React.Fragment>}
                    </td>
                ))}

                <td>
                    {this.props.row.pn.visible ? (
                        <span className="text-muted">{this.props.row.pn.value}</span>
                    ) : ''}
                </td>
            </tr>
        )
    }
}

class UnitTypeDHWCalculationPropertiesRow extends UnitTypeCalculationPropertiesRow {
    updateName = () => {
        store.setDHWName(this.state.value)
    }
}

class UnitTypeHeatingCalculationPropertiesRow extends UnitTypeCalculationPropertiesRow {
    updateName = () => {
        store.setHeatingName(this.props.editHeatingIdx, this.state.value)
    }
}

export {UnitTypeHeatingCalculationPropertiesRow, UnitTypeDHWCalculationPropertiesRow}